// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"d6fe6506","513":"b63e99f7","703":"3f21cb29","787":"50352550"}[chunkId] + ".chunk.js";
};